import SharedToolbar from '../../shared/shared-toolbar-latest';
import { UserKeys } from '../../api/users-api';
import { useQueryClient } from '@tanstack/react-query';
import SharedGridStateIconButton from '../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../shared/analytics/module-list';
import SharedIconButton from '../../shared/buttons/shared-icon-button';

export function OwnershipTransferLogsGridToolbar() {
  const queryClient = useQueryClient();
  return (
    <SharedToolbar
      secondaryButtons={
        <>
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.DriveTransferLogs],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="ownershipTransferLogsGridStates"
            module={ModuleList.modules.drive.name}
            section={ModuleList.modules.drive.sections.ownershipTransferLogs}
          />
        </>
      }
    />
  );
}
